import { render, staticRenderFns } from "./InvoiceCustomers.vue?vue&type=template&id=6a69eb1c&"
import script from "./InvoiceCustomers.vue?vue&type=script&lang=js&"
export * from "./InvoiceCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports